import React from 'react';
import { Box } from '@mui/material';
import appConfig from '../../config/appConfig';

const TeamLogo = ({ 
  team, 
  size = 40, 
  sx = {},
  onError = null,
  onLoad = null,
  showPlaceholder = false
}) => {
  // Get the logo URL from various possible team properties
  const getLogoUrl = () => {
    const logoPath = team.logoUrl || team.logo || team.logoPath;
    if (!logoPath) return null;
    
    // If it's already a full URL, return as-is
    if (logoPath.startsWith('http')) return logoPath;
    
    // Otherwise, prepend the API base URL
    return `${appConfig.apiBaseUrl || 'http://localhost:5131'}${logoPath}`;
  };

  const logoUrl = getLogoUrl();

  // If no logo URL and not showing placeholder, return null
  if (!logoUrl && !showPlaceholder) {
    return null;
  }

  return (
    <Box
      sx={{
        width: typeof size === 'string' ? size : size,
        height: typeof size === 'string' ? 'auto' : size,
        aspectRatio: typeof size === 'string' ? '1 / 1' : undefined,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderRadius: '4px',
        flexShrink: 0,
        ...sx
      }}
    >
      {logoUrl ? (
        <img 
          src={logoUrl}
          alt={`${team.name || team.teamName} logo`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: '4px'
          }}
          onError={(e) => {
            if (onError) {
              onError(e);
            } else {
              console.log(`Logo failed to load for ${team.name || team.teamName}:`, logoUrl);
              e.target.style.display = 'none';
            }
          }}
          onLoad={(e) => {
            if (onLoad) {
              onLoad(e);
            } else {
              console.log(`Logo loaded successfully for ${team.name || team.teamName}`);
            }
          }}
        />
      ) : showPlaceholder ? (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.1)',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: typeof size === 'number' ? size * 0.3 : '24px',
            color: 'text.disabled'
          }}
        >
          ?
        </Box>
      ) : null}
    </Box>
  );
};

export default TeamLogo;